import { useCallback, useContext, useState } from "react"
import { Item } from "../../../../../../../utils/types/generals"
import { useInput } from "./useInput"
import { useTranslation } from "react-i18next"
import { GlobalContext } from "../../../../../../../contexts/Global"
import { getPreviousYears, monthYear } from "../../../../../../../utils/constants/date_month"
import { Status } from "../../../../../../../utils/enums"
import { getStatus } from "../../../../../../../hooks/status"


const useGetData = () => {
  const [items, setItems] = useState<{ [x: string]: Item[] }>({})
  const { input } = useInput({ items })
  const { t } = useTranslation()
  const { colors } = useContext(GlobalContext)

  const getData = useCallback(async () => {
    getItemStatus()
    setItems((prev) => ({
      ...prev,
      createYear: getPreviousYears(),
      month: monthYear.map((e) => ({
        ...e,
        value: e.value + 1,
      })),
    }))

  }, [])



  const getItemStatus = async () => {
    const statusList = [Status.ACTIVE, Status.INACTIVE]

    setItems((prev) => ({
      ...prev,
      status: statusList.map((item) => {
        const status = getStatus(item, colors, t)
        return {
          label: status.text,
          value: status.value,
        }
      }),
    }))
  }


  return {  input, getData, items }
}

export { useGetData }
